export default __webpack_public_path__ + "static/media/practice-level-3.98967215.svg";